<template>
    <v-row>
        <v-col cols="12" sm="2">
            <div class="text-left">
                <span> {{ labelText }} </span>
            </div>                        
        </v-col>
        <v-col cols="12" sm="8">
            <div class="text-left">
                <template v-if="textfield">
                <span :v-model="textfield">{{ textfield }}</span>
                </template>
                <template v-for="(filename,index) in itemList">
                    <span v-bind:key="filename">{{ filename.name }} </span>
                    <span v-bind:key="filename + index">{{ filename.separator }}</span>
                </template>
                <template v-for="(file, index) in fileNameList">
                    <span v-bind:key="file.name + index">{{ file.name }}</span>
                    <span v-bind:key="file.name + index">{{ file.separator }}</span>
                </template>
            </div>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: 'SummaryGrid',
    props: ['labelText', 'arr', 'list', 'textfield'],
    computed: {
        fileNameList() {
            const fileList = [];
            if (this.list) {
                for (const [index, item] of this.list.entries()) {
                    fileList.push({
                        name: item.name,
                        separator: (index == this.list.length-1) ? '' : '; '
                    });
                }
            }
            return fileList;
        },
        itemList() {
            const itemList = [];
            if(this.arr) {
                for (const [index, filename] of this.arr.entries()) {
                    itemList.push({
                        name: filename,
                        separator: (index == this.arr.length-1) ? '' : '; '
                    })
                }
            }
            return itemList;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/customwidgets/SummaryGrid.vue